import React from 'react';
import Button from 'lib/components/button.jsx';
import { addClasses, mergeClasses } from 'lib/helpers/class.js';
import { buttonLooks, sizes } from 'lib/styles/constants.js';
import Dialog from 'lib/components/dialog.jsx';
import { useOpenClose } from 'lib/hooks/use-boolean-state.js';
import { Icon } from '@iconify-icon/react';

export function AddButton(props) {
    const { className, children, ...rest } = props;
    return (
        <Button
            className={className ?? addClasses('my-1')}
            look={buttonLooks.secondary}
            size={sizes.sm}
            type="button"
            {...rest}
        >
            {children ?? (
                <React.Fragment>
                    <Icon icon="material-symbols-light:add" width="1.6rem" height="1.6rem" />
                    {_t.bottone.aggiungi()}
                </React.Fragment>
            )}
        </Button>
    );
}

export function EditButton(props) {
    const { children, className, ...rest } = props;
    return (
        <Button
            look={buttonLooks.text}
            size={sizes.xs}
            type="button"
            className={addClasses(mergeClasses('-my-2 -ml-4 -mr-3', className))}
            {...rest}
        >
            {children ?? (
                <React.Fragment>
                    <Icon icon="material-symbols:edit-outline-rounded" width="1.2rem" height="1.2rem" />
                    <span className="sr-only">{_t.global.edit()}</span>
                </React.Fragment>
            )}
        </Button>
    );
}

export function DeleteButton(props) {
    const { children, onDelete, busy, ...rest } = props;

    const confirmDelete = useOpenClose();

    return (
        <React.Fragment>
            <Button look={buttonLooks.text} size={sizes.sm} onClick={confirmDelete.open} {...rest}>
                {children ?? (
                    <React.Fragment>
                        <Icon icon="ph:trash" width="1.3rem" height="1.3rem" className="mr-1" />
                        <span className="sr-only">{_t.bottone.elimina()}</span>
                    </React.Fragment>
                )}
            </Button>
            <Dialog.Full
                title={_t.bottone.confermaElimina()}
                isOpen={confirmDelete.isOpen}
                onClose={confirmDelete.close}
            >
                <div className="flex flex-wrap items-baseline justify-end gap-2">
                    <Button destructive busy={busy} onClick={onDelete}>
                        {_t.bottone.conferma()}
                    </Button>
                    <Button onClick={confirmDelete.close}>{_t.bottone.annulla()}</Button>
                </div>
            </Dialog.Full>
        </React.Fragment>
    );
}
